import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import * as actions from '../../app/actions';
import * as selectors from '../../app/selectors'
import * as geometricElementSelectors from '../../geometricElements/selectors'
import { connect, useDispatch } from 'react-redux';
import { getServiceToken } from '../../../backend/appFetch';
import { generateIdentificatorForLoadingAction } from '../../app/util';
import axios from 'axios';
import { Errors } from '../../common';
import { getInternationalization } from '../../app/components/InternationalizationRender';
import users from '../../users';
import { Formik, Field, Form } from 'formik';

const mapStateToProps = function (state) {
    return ({
        loading: selectors.isLoading(state),
        language: selectors.getLanguage(state),
        activeLanguages: selectors.getActiveLanguages(state),
        allCodes: geometricElementSelectors.getAllCodes(state),
        isAdmin: users.selectors.isAdmin(state)
    });
}

const ExportGeometricElementsAsShapeConfirmation = ({ modalShow, onClose, id, code, loading, empty, ownElements, ...props }) => {

    const dispatch = useDispatch();

    const [backendErrors, setBackendErrors] = useState(null);
    const [downloadLink, setDownloadLink] = useState(null);
    const [fileDownloadError, setFileDownloadError] = useState(false);

    const closeModalWindow = (resetForm) => {

        onClose();
        setBackendErrors(null);
        setDownloadLink(null);
        setFileDownloadError(false);
        resetForm();
    }

    let initialValues = {
        userVersion: props.isAdmin ? false : true
    }

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={(values, { setSubmitting }) => {
                setBackendErrors(null);
                setDownloadLink(null);
                const loadingId = generateIdentificatorForLoadingAction();
                dispatch(actions.loading(loadingId));

                axios({
                    url: `${process.env.REACT_APP_BACKEND_URL}/elements/geometric_element_type/export`,
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${getServiceToken()}`,
                        'Content-Type': 'application/json'
                    },
                    data: {
                        geometricElementTypeId: id,
                        ownElements: ownElements,
                        empty: empty,
                        userVersion: values.userVersion
                    },
                    responseType: 'text'
                }).then((response) => {

                    dispatch(actions.loaded(loadingId));
                    setDownloadLink(`${process.env.REACT_APP_BACKEND_URL}/elements/geometric_element_type/export/download?filename=${response.data}`);
                }).catch(error => {

                    console.log(error.response.data);
                    dispatch(actions.loaded(loadingId));
                    setBackendErrors(error.response.data);
                });
                setSubmitting(false);
            }}
        >
            {({ resetForm }) =>
                <Modal backdrop="static" show={modalShow} onHide={() => closeModalWindow(resetForm)} scrollable={true} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <FormattedMessage id="project.elements.export.button" />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="needs-validation novalidate" id="exportAsShapeConfirmationForm">

                            <Errors errors={backendErrors} onClose={() => setBackendErrors(null)} />

                            {fileDownloadError && downloadLink && <div className="alert alert-danger" role="alert">
                                <FormattedHTMLMessage id="project.elements.export.download.error" />
                            </div>}

                            {!fileDownloadError && !downloadLink && <div className={`alert ${empty ? 'alert-info' : 'alert-warning'}`} role="alert">
                                <FormattedHTMLMessage id={empty ?
                                    "project.elements.export.confirmation.emptyMessage" : "project.elements.export.confirmation.message"} />
                            </div>}

                            {!fileDownloadError && downloadLink && <div className="alert alert-success" role="alert">
                                <FormattedHTMLMessage id="project.elements.export.download.confirmation" />
                            </div>}

                            {props.isAdmin && !fileDownloadError && !downloadLink &&
                                <div className="form-group">
                                    <label htmlFor="userVersion" className="font-weight-bold">
                                        <FormattedMessage id="project.elements.export.version" />
                                    </label>
                                    <Field as="select" id="userVersion" name="userVersion" className="form-control">
                                        <option value="false">
                                            {props.intl.formatMessage({ id: "project.elements.export.version.admin" })}
                                        </option>
                                        <option value="true">
                                            {props.intl.formatMessage({ id: "project.elements.export.version.user" })}
                                        </option>
                                    </Field>
                                </div>}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        {!fileDownloadError && downloadLink && <button disabled={loading} id="downloadFile" className="btn btn-primary"
                            onClick={() => {
                                const loadingId = generateIdentificatorForLoadingAction();
                                setBackendErrors(null);
                                dispatch(actions.loading(loadingId));

                                axios({
                                    url: downloadLink,
                                    method: 'GET',
                                    headers: {
                                        'Authorization': `Bearer ${getServiceToken()}`
                                    },
                                    responseType: 'blob'
                                }).then((response) => {

                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', getInternationalization(props.language, code, props.allCodes, props.activeLanguages)
                                        + `${empty ? ` ${props.intl.formatMessage({ id: 'project.elements.export.model' })}` : ''}.zip`);
                                    document.body.appendChild(link);
                                    link.click();

                                    closeModalWindow(resetForm);
                                    document.body.removeChild(link);
                                    dispatch(actions.loaded(loadingId));
                                    setDownloadLink(null);
                                }).catch(error => {

                                    dispatch(actions.loaded(loadingId));
                                    setFileDownloadError(true);
                                    console.log(error);
                                });
                            }}>
                            <FormattedMessage id="project.elements.export.download" />
                        </button>}
                        {!fileDownloadError && !downloadLink && <button id="confirmExport" type="submit" className="btn btn-primary"
                            disabled={loading} form="exportAsShapeConfirmationForm"
                        >
                            <FormattedMessage id="project.elements.export.confirmation.button" />
                        </button>}
                        <button id="cancelButton" type="button" className="btn btn-danger"
                            disabled={loading}
                            onClick={() => closeModalWindow(resetForm)}
                        >
                            <FormattedMessage id="project.app.Body.cancel" />
                        </button>
                    </Modal.Footer>
                </Modal>}
        </Formik>
    );
}

export default connect(mapStateToProps)(injectIntl(ExportGeometricElementsAsShapeConfirmation));